export const PC_SUBSCRIPTION_ID = '784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e';
export const MARIS_PICKS_SUBSCRIPTION_ID =
  'e59cd67d-084f-48c4-b51f-3d20750e793f';
export const MINIMUM_CART_QUANTITY_FOR_PC_AUTO_ENROLL = 6;
export const PURCHASE_WITH_PURCHASE_MAGNUM =
  'e8c05d06-755a-47a7-8329-2c4f3da4dbb6';
export const PURCHASE_WITH_PURCHASE_MAY_MIXED_PACK =
  '2539a0e2-d34f-4d1d-9763-a8e8cd8e2048';
export const PURCHASE_WITH_PURCHASE_JUNE_MIXED_PACK =
  'cf950e4b-8719-4a85-a337-d099d852a0bd';
export const PURCHASE_WITH_PURCHASE_JULY_MIXED_PACK =
  'f48e88e3-a34f-4055-87ef-d225897d3e00';
export const PURCHASE_WITH_PURCHASE_AUGUST_MIXED_PACK =
  'bc47e019-35a8-4eeb-96e8-cc36f853b5cc';
export const PURCHASE_WITH_PURCHASE_SEPTEMBER_MIXED_PACK =
  '4d48e61f-87a2-4187-a225-23eb051e88c7';
export const PURCHASE_WITH_PURCHASE_OCTOBER_MIXED_PACK =
  'e4c74c94-b969-42cd-95cb-179bd5306c14';
export const PURCHASE_WITH_PURCHASE_NOVEMBER_MIXED_PACK =
  '89f94a2b-72f1-4c7b-adb9-e1181663878d';
export const PURCHASE_WITH_PURCHASE_DECEMBER_MIXED_PACK =
  '9bf289dd-bc38-4afb-9d9c-3db90875d9d6';
export const PURCHASE_WITH_PURCHASE_JANUARY_MIXED_PACK =
  'c3d0aa33-6560-42b3-82ef-136669aeef9d';
export const PURCHASE_WITH_PURCHASE_FEBRUARY_MIXED_PACK =
  '676bc92a-1b38-4a16-8ff1-ea76936e136b';
export const PURCHASE_WITH_PURCHASE_MARCH_MIXED_PACK =
  '16dd99f3-5a31-43ac-832a-243579fedb15';
export const PURCHASE_WITH_PURCHASE_APRIL_MIXED_PACK_2021 =
  '92c0709c-55d8-421b-a673-dc24d020ec81';
export const PURCHASE_WITH_PURCHASE_MAY_MIXED_PACK_2021 =
  '7e86bc10-4203-4078-a006-ba8394422f20';
export const PURCHASE_WITH_PURCHASE_JUNE_MIXED_PACK_2021 =
  '4f3661e6-9d11-43bc-872e-6f4cc1df744f';

export const purchaseWithPurchaseProducts = [
  PURCHASE_WITH_PURCHASE_MAY_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_JUNE_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_JULY_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_AUGUST_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_SEPTEMBER_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_OCTOBER_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_NOVEMBER_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_DECEMBER_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_JANUARY_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_FEBRUARY_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_MARCH_MIXED_PACK,
  PURCHASE_WITH_PURCHASE_APRIL_MIXED_PACK_2021,
  PURCHASE_WITH_PURCHASE_MAY_MIXED_PACK_2021,
  PURCHASE_WITH_PURCHASE_JUNE_MIXED_PACK_2021,
];
